export default class ModalBookmarkAddController {
	/* @ngInject */
	constructor($uibModalInstance, bookmark) {
		this.$uibModalInstance = $uibModalInstance;
		this.bookmark = bookmark;
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}

	submit() {
		this.$uibModalInstance.close(this.bookmark);
	}
}
